import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoPipe, translate} from '@jsverse/transloco';
import {BadgeModule} from 'primeng/badge';
import {ModuleFunction} from '@frontend/directus';
import {ModuleFunctionStatusBadgeComponent} from '../module-function-status-badge/module-function-status-badge.component';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {ModuleSystemRecording, ToolIntegrationType} from '@frontend/shared';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-hr-system-recording-card',
  imports: [
    CommonModule,
    TranslocoPipe,
    BadgeModule,
    ModuleFunctionStatusBadgeComponent,
    TranslateDirectusPipe,
    Tooltip,
  ],
  templateUrl: './hr-system-recording-card.component.html',
})
export class HrSystemRecordingCardComponent {
  readonly moduleFunctions = input.required<ModuleFunction[]>();
  readonly moduleSystemRecording = input.required<ModuleSystemRecording>();
  readonly centered = input<boolean>(false);

  protected readonly translationMap = computed(() => {
    return new Map(this.moduleFunctions().map((f) => [f.id, f.translations]));
  });
  protected readonly moduleFunctionSystemRecordings = computed(
    () => this.moduleSystemRecording().moduleFunctionSystemRecordings,
  );

  protected cardBorderBgColor(): string {
    const type = this.moduleSystemRecording().toolIntegrationType;
    switch (type) {
      case ToolIntegrationType.NEW:
        return 'card-new-system';
      case ToolIntegrationType.FUTURE:
        return 'card-future-system';
      default:
        return '';
    }
  }

  protected hrProviderTitle(): string {
    const type = this.moduleSystemRecording().toolIntegrationType;
    switch (type) {
      case ToolIntegrationType.NEW:
        return translate('project.steps.systemFlow.newSystem');
      case ToolIntegrationType.FUTURE:
        return translate('project.steps.systemFlow.futureSystem');
      default:
        return this.moduleSystemRecording().hrToolProviderName;
    }
  }

  protected hrToolName(): string {
    const type = this.moduleSystemRecording().toolIntegrationType;
    switch (type) {
      case ToolIntegrationType.NEW:
        return translate('project.steps.systemFlow.newTool');
      case ToolIntegrationType.FUTURE:
        return translate('project.steps.systemFlow.futureTool');
      default:
        return this.moduleSystemRecording().hrToolName;
    }
  }

  protected readonly moduleFunctionsCount = computed(
    () => this.moduleFunctionSystemRecordings().length,
  );
}
